import LeftBarHero from "./LeftBarHero";
import RightBarHero from "./RightBarHero";
import Wave from "./Wave";
function Hero() {
    return (
        <div className="Hero" id="home">
            <LeftBarHero></LeftBarHero>
            <RightBarHero></RightBarHero>
            <Wave up={true}></Wave>
        </div>
    );
}
  
export default Hero;